import script from "./GithubContributions.vue?vue&type=script&setup=true&lang=js"
export * from "./GithubContributions.vue?vue&type=script&setup=true&lang=js"

import "./GithubContributions.vue?vue&type=style&index=0&id=7ea6f729&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7ea6f729"]])

export default __exports__